import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=10ed5695&scoped=true"
import script from "./remark.vue?vue&type=script&lang=js"
export * from "./remark.vue?vue&type=script&lang=js"
import style0 from "./remark.vue?vue&type=style&index=0&id=10ed5695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed5695",
  null
  
)

export default component.exports